/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * HomeScreen dimmer states (visual phases) — managed as ViewModel state.
 *
 * - SEMI:  dimmer at ~50%, menu strip + carousels visible.
 * - FULL:  Down pressed in carousel — dimmer at ~100%, full navigation mode.
 */
export enum HomeScreenDimmerState {
  SEMI = "semi",
  FULL = "full"
}
